import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Tracks when a captured text is copied to a clipboard',
  name: 'copied_captured_text',
  params: [
    {
      description: 'The ID of the captured text',
      name: 'text_id',
      required: true,
      type: 'string',
    },
    {
      description: 'The captured text',
      name: 'text',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
